import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

const AdminRoute = ({ children }) => {
  const token = window.localStorage.getItem('token');
  let parsedItem = null;

  try {
    parsedItem = token ? JSON.parse(token).data.user_data : null;
  } catch (e) {
    console.error("Failed to parse token:", e);
  }

  const allowedRoles = ['CLIENT', 'ADMIN'];
  const isAuthorized = parsedItem && allowedRoles.includes(parsedItem.role);

  if (!isAuthorized) {
    return <Navigate to="/unauthorised" replace />;
  }

  return children;
};

AdminRoute.propTypes = {
  children: PropTypes.node.isRequired
};

export default AdminRoute;
